module.exports = __webpack_public_path__ + "img/active_tab_bg.4604f75f.png";